import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { EuiPage, EuiPageBody, EuiContext } from "@elastic/eui"
import { ViewHome } from "./components/view/ViewHome"

const App: React.FC = () => {
  const translations = {}

  return (
    <EuiContext i18n={{ mapping: translations }}>
      <Router>
        <EuiPage>
          <EuiPageBody>
            <Switch>
              <Route>
                <ViewHome />
              </Route>
            </Switch>
          </EuiPageBody>
        </EuiPage>
      </Router>
    </EuiContext>
  )
}

export default App
